import { HttpGETCustomOptions } from '../models';

export const DEFAULT_HTTP_GET_CUSTOM_OPTIONS: HttpGETCustomOptions = {
  forceAPICall: false,
};
